module.exports = __webpack_public_path__ + "img/1200_custom-Smishing-avatar.45ad16a5.png";